import type { RadioProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

//
import { RadioCheckedIcon, RadioIcon } from './CustomIcons';

const Radio = (theme: Theme) => {
  return {
    MuiRadio: {
      defaultProps: {
        checkedIcon: <RadioCheckedIcon />,
        icon: <RadioIcon />,
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: RadioProps }) => ({
          padding: theme.spacing(1),
          ...(ownerState.size === 'small' && {
            '& svg': { height: 20, width: 20 },
          }),
          ...(ownerState.size === 'medium' && {
            '& svg': { height: 24, width: 24 },
          }),
        }),
      },
    },
  };
};

export default Radio;
